const KEYWORDS = [
  'külot', 'kulot', 'kilot', 'sutyen', 'sütyen', 'bra', 'panty', 'panties', 'underwear',
  'lingerie', 'slip', 'iç giyim', 'ic giyim', 'ic-giyim', 'tanga', 'string',
  'g-string', 'thong', 'babydoll', 'gecelik', 'jartiyer', 'garter', 'corset',
  'korse', 'teddy', 'seksi', 'sexy', 'erotic', 'erotik', 'fantazi', 'fantezi',
  'iç çamaşır', 'ic camasir', 'bikini', 'mayo', 'swimsuit', 'swimwear',
  'vücut zinciri', 'vucut zinciri', 'bel zinciri', 'body chain', 'waist chain',
  'bacak zinciri', 'göbek zinciri', 'belly chain', 'fileli çorap', 'nipple', 'meme ucu',
  'crotchless', 'açık bölge', 'open crotch', 'open bust', 'open chest',
  'fantezi giyim', 'fantezi-giyim', 'intimate', 'intimates', 'harness', 'herness', 'clubwear',
  'body-harness', 'nightgown',
  'büstiyer', 'bustiyer', 'bustier', 'bralet', 'bralette',
  'badi', 'bodysuit', 'boxer', 'jockstrap', 'kombinezon', 'jüpon', 'jupon',
  'ağız topu', 'agiz topu', 'kırbaç', 'kirbac', 'kelepçe set', 'kelepce set', 'slave',
];

const TR_SUFFIX = '(?:l[ıiuü]|s[ıiuü]z|l[ae]r[ıi]?|[ıiuü]|n[ıiuü]|y[ıiuü]|s|es|ed|ing)?';
const SHORT_SUFFIX = '(?:s|es)?';

const EDGE_BEFORE = '(?:^|[^\\p{L}\\p{N}])';
const EDGE_AFTER = '(?=$|[^\\p{L}\\p{N}])';
const LAUNDRY_BRA = new RegExp(`${EDGE_BEFORE}bra\\s+(?:washing|protector|ball)${EDGE_AFTER}`, 'u');
const MODEST_SWIM = new RegExp(`${EDGE_BEFORE}(?:hijab|tesettür|tesettur|fully covered|kapalı mayo)${EDGE_AFTER}`, 'u');
const LINGERIE_BODY = new RegExp(`${EDGE_BEFORE}(?:body|badi|bodysuit)${EDGE_AFTER}`, 'u');
const BODY_SAFE = new RegExp(
  `${EDGE_BEFORE}(?:t-?shirt|tişört|tisort|tisört|sweat|bebek|çocuk|cocuk|losyon|lotion|mist|spray|krem|şampuan|sampuan|sabun|penye|viskon|viscon|bisiklet|balıkçı|balikci|uzun kollu)${EDGE_AFTER}`,
  'u',
);
const GARMENT_STORAGE = /(?:organizer|düzenleyici|duzenleyici|çekmece|cekmec)/u;
const BODY_RISK = new RegExp(
  `${EDGE_BEFORE}(?:dantel(?:li)?|fisto|tül|tul|file|transparan|straples|straplez|strapless)${EDGE_AFTER}`,
  'u',
);
const SHEER_HOSIERY = new RegExp(
  `${EDGE_BEFORE}file${EDGE_AFTER}.{0,30}${EDGE_BEFORE}(?:çorap|corap|külotlu|kulotlu)${EDGE_AFTER}`,
  'u',
);
const LACE_CAMISOLE = new RegExp(
  `${EDGE_BEFORE}dantel(?:li)?${EDGE_AFTER}.{0,24}${EDGE_BEFORE}atlet${EDGE_AFTER}|${EDGE_BEFORE}atlet${EDGE_AFTER}.{0,24}${EDGE_BEFORE}dantel(?:li)?${EDGE_AFTER}`,
  'u',
);

function foldTr(value) {
  return String(value || '').replace(/İ/g, 'i').replace(/I/g, 'ı').toLowerCase();
}

function escapeRegExp(value) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

const SENSITIVE_PATTERN = new RegExp(
  `(^|[^\\p{L}\\p{N}])(?:${KEYWORDS.map((keyword) => {
    const folded = foldTr(keyword);
    const suffix = folded.length <= 3 ? SHORT_SUFFIX : TR_SUFFIX;
    return `${escapeRegExp(folded)}${suffix}`;
  }).join('|')})(?=$|[^\\p{L}\\p{N}])`,
  'u',
);

function productText(product) {
  return [
    product?.name,
    product?.name_tr,
    product?.category,
    product?.category_tr,
    product?.subcategory,
    product?.subcategory_tr,
    product?.category_path,
  ]
    .filter(Boolean)
    .join(' ');
}

function foldedProductText(product) {
  return foldTr(productText(product));
}

/** Çıplak / iç giyim görseli. Çamaşır topu gibi yanlış eşleşmeler bulanıklaşmaz. */
export function shouldBlurSensitiveImage(product) {
  if (!product) return false;
  const blob = foldedProductText(product);
  if (LAUNDRY_BRA.test(blob) || MODEST_SWIM.test(blob) || GARMENT_STORAGE.test(blob)) return false;
  if (SHEER_HOSIERY.test(blob) || LACE_CAMISOLE.test(blob)) return true;
  if (LINGERIE_BODY.test(blob) && (BODY_RISK.test(blob) || !BODY_SAFE.test(blob))) return true;
  return SENSITIVE_PATTERN.test(blob);
}

/** Ana sayfadan çıkar: işaretli ürünler ve çıplak/iç giyim başlıkları. */
export function isSensitiveProduct(product) {
  if (!product) return false;
  if (shouldBlurSensitiveImage(product)) return true;
  const blob = foldedProductText(product);
  if (LAUNDRY_BRA.test(blob) || MODEST_SWIM.test(blob) || GARMENT_STORAGE.test(blob)) return false;
  return Boolean(product.is_sensitive || product.hide_from_homepage);
}

export function withoutSensitiveProducts(products) {
  return (products || []).filter((product) => !isSensitiveProduct(product));
}
